export default __webpack_public_path__ + "static/media/CNo.83-0.3b445126.jpg";